import * as React from "react";

;
export const Backward = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="#fff" {...props}><path d="m9.374 12 5.647 5.646-.708.707L7.96 12l6.353-6.354.708.708L9.374 12Z" /></svg>;